export enum USER_MENU {
  MY_DONEDEAL = 'mydonedeal',
  MY_ADS = 'myads',
  MESSAGES = 'messages',
  SAVED = 'saved',
  SEARCHES = 'searches',
  HISTORY_CHECKS = 'history-checks',
  PAYMENTS = 'payments',
  USER_LOGOUT = 'log_out',
  USER_LOGIN = 'login',
  USER_SIGN_UP = 'sign_up',
  HELP = 'help',
  BROWSING_HISTORY = 'browsing-history',
}

export enum USER_MENU_DISPLAY_NAMES {
  MY_DONEDEAL = 'Profile',
  MY_ADS = 'My Ads',
  MESSAGES = 'Messages',
  SAVED = 'Saved Ads',
  SEARCHES = 'Saved Searches',
  HISTORY_CHECKS = 'History Checks',
  PAYMENTS = 'Payment History',
  BROWSING_HISTORY = 'Browsing History',
}

export type UserMenuProps = {
  messages?: number;
  historyChecks?: number;
  user?: {
    isUserLogged: boolean;
    onUserLogOut: () => void;
    onUserLogIn: () => void;
  };
  help?: boolean;
  variant?: 'DASHBOARD';
  selectedSection?: USER_MENU;
  showMore?: boolean;
  /**
   * A next link prop that updates the URL when a link is clicked without reloading the page.
   *
   * This may be used with the dashboard where the menu should be visible at all times although the URL
   * may change, updating the content on the page but not the menu.
   *
   * This allows for animations associated with the menu to work as expected, such as the slider that moves to
   * a newly selected section.
   */
  displayNextLinkAsShallow?: boolean;
};
